import fromPairs from 'lodash-es/fromPairs';
import sum from 'lodash-es/sum';
import {
  ProductClass,
} from '../../graphQL/types/shared';
import {
  getServiceCategoryNumber,
} from '../../sharedComponents/getIsService';
import {
  getProductSearchString,
  ILoadable,
  INewDropdownOption,
  LoadableStatus,
} from '../../Utils';
import {
  newGetProductDropdownLabel,
} from '../../Utils';
import {
  ISize,
} from '../network/Utils';

import { extractFromStringProductId } from '../../graphQL/Utils';
import getValueFunction from './getValueFunction';
import {
  ExportType,
  HideExports,
  IAssignRadiusOutput,
  IComputationOutput,
  IProcessedNode,
  ValueGetter,
} from './Utils';

const getExportedAndUnexportedValue = getValueFunction(HideExports.Off);

const applyCategoryFilter = (
    hideExports: HideExports,
    getValue: ValueGetter,
    deselectedCategories: number[],
    availableYearsStatus: ILoadable<number[]>,
    radiusAssignedStatus: ILoadable<IAssignRadiusOutput>,
    sizeStatus: ILoadable<ISize>,
    productClass: ProductClass,
  ): ILoadable<IComputationOutput> => {

  let result: ILoadable<IComputationOutput>;
  if (radiusAssignedStatus.status === LoadableStatus.Initial ||
      availableYearsStatus.status === LoadableStatus.Initial ||
      sizeStatus.status === LoadableStatus.Initial) {

    result = {status: LoadableStatus.Initial};
  } else if (radiusAssignedStatus.status === LoadableStatus.Loading ||
              availableYearsStatus.status === LoadableStatus.Loading ||
              sizeStatus.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (radiusAssignedStatus.status === LoadableStatus.NotPresent ||
              availableYearsStatus.status === LoadableStatus.NotPresent ||
              sizeStatus.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {
      data: {
        nodes: unfiltered,
        xAxisMin, xAxisMax,
        yAxisMin, yAxisMax,
        yAverage,
      },
    } = radiusAssignedStatus;
    const {data: availableYears} = availableYearsStatus;
    const {data: {width, height}} = sizeStatus;

    const serviceCategory = getServiceCategoryNumber(productClass);
    const deselectedCategoriesWithServices = [...deselectedCategories, serviceCategory];

    const assignedActive: IProcessedNode[] = unfiltered.map(node => ({
      ...node,
      isTopProduct: false,
      active: !deselectedCategoriesWithServices.includes(extractFromStringProductId(node.section).id),
    }));

    // Filter out nodes that are exported if necessary:
    let filteredByCategoryAndExports: IProcessedNode[];
    if (hideExports === HideExports.Off) {
      filteredByCategoryAndExports = assignedActive;
    } else {
      filteredByCategoryAndExports = assignedActive.filter(
        ({exportStatus}) => exportStatus.type !== ExportType.WhollyExported,
      );
    }

    const unfilteredTotal = sum(unfiltered.map((getExportedAndUnexportedValue)));

    const total = sum(filteredByCategoryAndExports.map(getValue));

    const tooltipPairs = filteredByCategoryAndExports.map(
      datum => ([datum.id, datum] as [string, IProcessedNode]),
    );
    const tooltipMap: Record<string, IProcessedNode> = fromPairs(tooltipPairs);

    const dropdownOptions: INewDropdownOption[] = [...filteredByCategoryAndExports].sort(
      (a, b) => (a.code < b.code) ? -1 : 1,
    ).map(
      ({shortLabel, code, id, level}) => ({
        value: id,
        label: newGetProductDropdownLabel(shortLabel, productClass, code, level),
        searchString: getProductSearchString(shortLabel, productClass, code),
      }),
    );

    result = {
      status: LoadableStatus.Present,
      data: {
        nodes: filteredByCategoryAndExports,
        tooltipMap, total, availableYears,
        xAxisMin, xAxisMax,
        yAxisMin, yAxisMax,
        dropdownOptions,
        yAverage,
        svgWidth: width, svgHeight: height,
        unfilteredTotal,
      },
    };
  }
  return result;
};

export default applyCategoryFilter;
